import { Injectable } from '@angular/core';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';

@Injectable()
export class ModalService {
  private readonly DEFAULT_NOTIFICATION_SHOWING_TIME = 10;
  private modalActiveRefs: any[] = [];


  constructor(private _modalService: NgbModal) {
  }

  /**
   * this methd is used to open an Achoo popup
   * @param {AchooPopupComponent} modalComponent
   */
  public open(modalComponent: AchooPopupComponent, dismissCallback?: any, isNotification?: boolean, showingTime = 10): any {
    let newActiveModalRef;

    if (!modalComponent) {
      return;
    }

    if (isNotification) {
      newActiveModalRef = this._modalService.open(modalComponent.content, {
        backdropClass: 'notification-backdrop',
        windowClass: 'notification-open',
        beforeDismiss: this.beforeDismissModal.bind(this, dismissCallback, true)
      });

      document.body.classList.add('has-notification');

      // notificqtion will close after 3 seconds automatically
      setTimeout(() => {
        // call dismiss callback
        this.beforeDismissModal(dismissCallback, true);
        // close modal
        this.closeSinglePopup(newActiveModalRef);
      }, showingTime * 1000);
    } else {
      newActiveModalRef = this._modalService.open(modalComponent.content, {
        beforeDismiss: this.beforeDismissModal.bind(this, dismissCallback, false)
      });
    }
    this.modalActiveRefs.push(newActiveModalRef);
    return newActiveModalRef;
  }

  /**
   * Allow to show multiple modal instances in the same time
   * @param {AchooPopupComponent} modalComponent
   * @param dismissCallback
   * @returns {any}
   */
  public openMultipleModal(modalComponent: AchooPopupComponent, dismissCallback?: any): any {
    let newActiveModalRef;

    if (!modalComponent || !modalComponent.isNotification) {
      return;
    }

    newActiveModalRef = this._modalService.open(modalComponent.content, {
      backdropClass: 'notification-backdrop',
      windowClass: 'notification-open',
      container: '#notification_container',
      beforeDismiss: this.beforeDismissModal.bind(this, dismissCallback, true)
    });

    document.body.classList.add('has-notification');

    // notificqtion will close after 3 seconds automatically
    setTimeout(() => {
      // call dismiss callback
      this.beforeDismissModal(dismissCallback, true);
      // close modal
      this.closeSinglePopup(newActiveModalRef);
    }, this.DEFAULT_NOTIFICATION_SHOWING_TIME * 1000);
    return newActiveModalRef;
  }

  public openInCenter(modalComponent: AchooPopupComponent, dismissCallback?: any, windowClass?: string, isStatic?: boolean): any {
    const newModalActiveRef = this._modalService.open(modalComponent.content, {
      centered: true,
      windowClass: windowClass || null,
      beforeDismiss: this.beforeDismissModal.bind(this, dismissCallback, false),
      backdrop: isStatic ? 'static' : true
    });

    this.modalActiveRefs.push(newModalActiveRef);
    return newModalActiveRef;
  }

  /**
   * this method is used to close ALL opening Achoo popups
   * @param {string} reason
   */
  public close(reason?: string): void {
    if (this.modalActiveRefs.length === 0) {
      return;
    }
    document.body.classList.remove('has-notification');
    this.modalActiveRefs.forEach((modal) => modal.close(reason));
    this.modalActiveRefs = [];
  }

  /**
   * This API is using to close a specific open popup
   * @param modalRef
   * @param {string} reason
   */
  public closeSinglePopup(modalRef: any, reason?: string): void {
    if (!modalRef) {
      return;
    }
    const closeModalIndex = this.modalActiveRefs.findIndex((modal) => modal === modalRef);
    if (closeModalIndex >= 0) {
      this.modalActiveRefs.splice(closeModalIndex, 1);
    }
    // close specific modal
    modalRef.close(reason);
  }

  private beforeDismissModal(dismissCallback, isNotification) {
    if (isNotification) {
      document.body.classList.remove('has-notification');
    }
    // executed dismiss callback before closing modal
    if (dismissCallback) {
      dismissCallback();
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/modal/modal.service.ts